export default {
  ativo(state) {
    return state.ativo;
  },
  produto(state) {
    return state.produto;
  },
  itens(state) {
    return state.itens;
  },
  parcelas(state) {
    return state.parcelas;
  },
  form(state) {
    return state.form;
  },
  selects(state) {
    return state.selects;
  }
};
